// extracted by mini-css-extract-plugin
export default {"suggestion":"styles_suggestion__Z-yhQ","active":"styles_active__8X4YO","description":"styles_description__7Ivj5"};